import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input/intlTelInputWithUtils"
import { pt, es } from "intl-tel-input/i18n"

// Campo de telefone internacional (intl-tel-input): seletor de pais com
// bandeira, DDI separado e validacao/formatacao da libphonenumber (utils
// embutidos). Para usar em QUALQUER campo de telefone, coloque o controller
// numa div em volta do campo (NUNCA no proprio input):
//   <div data-controller="telefone">
//     <%= render 'shared/fields/text_field', method: :telefone, ... %>
//   </div>
// O intl-tel-input MOVE o input para dentro de um wrapper proprio (.iti) ao
// iniciar. Se o controller estiver no input, o Stimulus enxerga o movimento
// como remocao+insercao e dispara disconnect/connect sem parar — trava o
// navegador. Na div externa nada se move e o ciclo nao existe.
// No submit o valor vira o numero completo em E.164 (+5531900000000) — um
// formato so no banco, independente de como a pessoa digitou.
const TRADUCOES = { "pt-BR": pt, pt: pt, es: es }

export default class extends Controller {
  connect() {
    this.input = this.element.querySelector("input")
    if (!this.input) return
    this.desfazerRestos()
    this.iti = intlTelInput(this.input, {
      initialCountry: "br",
      separateDialCode: true,
      countryOrder: ["br", "pt", "us", "es", "ar", "py", "uy"],
      i18n: TRADUCOES[document.documentElement.lang] || pt,
    })
    this.form = this.input.form
    this.aoSubmeter = () => {
      const completo = this.iti.getNumber()
      if (completo) this.input.value = completo
    }
    this.form?.addEventListener("submit", this.aoSubmeter)
  }

  // Depois de um restore do cache do Turbo o HTML volta com o wrapper .iti da
  // visita anterior, mas sem instancia viva por tras. Desfaz o wrapper para o
  // init comecar limpo em vez de aninhar um .iti dentro do outro.
  desfazerRestos() {
    const resto = this.input.closest(".iti")
    if (resto) {
      resto.parentNode.insertBefore(this.input, resto)
      resto.remove()
    }
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.aoSubmeter)
    this.iti?.destroy()
    this.iti = null
  }
}
